import { render, staticRenderFns } from "./ChatTemplatesOverlay.vue?vue&type=template&id=1a39c87e&scoped=true&"
import script from "./ChatTemplatesOverlay.vue?vue&type=script&lang=js&"
export * from "./ChatTemplatesOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ChatTemplatesOverlay.vue?vue&type=style&index=0&id=1a39c87e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a39c87e",
  null
  
)

export default component.exports